import { render, staticRenderFns } from "./AdminEditPlace.vue?vue&type=template&id=f5310c0c"
import script from "./AdminEditPlace.vue?vue&type=script&lang=js"
export * from "./AdminEditPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports